import { fetcher } from '@commenda/utils';

type DeleteProductResult = {
  success: boolean;
  error?: string;
};

export async function deleteIndirectTaxProduct(
  productId: string,
  corporationId: number,
  token?: string
): Promise<DeleteProductResult> {
  try {
    const response = await fetcher(
      `new-sales-tax/products/${productId}/corporation/${corporationId}`,
      { method: 'DELETE' },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to delete product',
      };
    }

    return { success: true };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to delete product';
    return { success: false, error: errorMessage };
  }
}
